import { defaultClient } from '@mint-sdk/api-core';

import { workspacePlatformsInUseSchema } from '../shared/schemas/workspace.js';

export const getPlatformsInUseQueryOptions = defaultClient.query({
  url: 'planning-service/workspace/platforms-in-use',
  method: 'GET',
  responseSchema: workspacePlatformsInUseSchema,
  processResponse(data) {
    return data.data?.items;
  },
});
